/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { FunctionComponent } from 'react'
import Logo from '../../../components/store-list/logo'

import IStore from '../store'

import style from './index.scss'

interface StoreSummaryProps {
  onClick: () => void
  store: IStore
}

const StoreSummary: FunctionComponent<StoreSummaryProps> = ({
  onClick,
  store,
}) => (
  <div className={style.storeItem} role="button" tabIndex={0} onClick={onClick}>
    <Logo name={store.title} logo={store.logo} />
  </div>
)

export default StoreSummary
